
export const CareSVG = ({ stroke = '#6C6F70' }) => {
  return (
    <svg width="40" height="40" viewBox="0 0 36 37" fill="none">
      <path
        d="M22.8889 11.0001H24C24.5304 11.0001 25.0391 11.205 25.4142 11.5696C25.7893 11.9343 26 12.4289 26 12.9446V26.5557C26 27.0714 25.7893 27.566 25.4142 27.9306C25.0391 28.2953 24.5304 28.5001 24 28.5001H12C11.4696 28.5001 10.9609 28.2953 10.5858 27.9306C10.2107 27.566 10 27.0714 10 26.5557V12.9446C10 12.4289 10.2107 11.9343 10.5858 11.5696C10.9609 11.205 11.4696 11.0001 12 11.0001H13.1111"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2307 8.50012H14.7692C14.1744 8.50012 13.6923 8.91986 13.6923 9.43762V11.3126C13.6923 11.8304 14.1744 12.2501 14.7692 12.2501H21.2307C21.8255 12.2501 22.3076 11.8304 22.3076 11.3126V9.43762C22.3076 8.91986 21.8255 8.50012 21.2307 8.50012Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6924 17.389H22.3078"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <mask id="path-4-inside-1_1587_23981" fill="white">
        <rect x="12.4615" y="19.6112" width="11.0769" height="6.66667" rx="1" />
      </mask>
      <rect
        x="12.4615"
        y="19.6112"
        width="11.0769"
        height="6.66667"
        rx="1"
        stroke={stroke}
        strokeWidth="3"
        mask="url(#path-4-inside-1_1587_23981)"
      />
    </svg>
  );
};
